import { PageHeader } from "../../page-header";
import { usePagamentoLote } from "../../../hooks/usePagamentoLote";
import { formatValueToMonetary } from "../../../utils/formatter";
import { Link } from "react-router-dom";
import { TbLayoutList, TbCheck, TbAlertTriangle, TbClock, TbCalendarCheck } from "react-icons/tb";
import "../PagamentoLote.css";
import "./PagamentoLoteDashboard.css";

function dateBR(dateStr) {
  return new Date(dateStr + "T00:00:00").toLocaleDateString("pt-BR");
}

const BATCH_STATUS_LABELS = {
  RASCUNHO: "Rascunho",
  AGUARDANDO_APROVACAO: "Aguardando aprovação",
  EM_PROCESSAMENTO: "Em processamento",
  PAGO: "Pago",
  PARCIALMENTE_PAGO: "Parcialmente pago",
  COM_ALERTA: "Com alerta",
  FALHOU: "Falhou",
  REJEITADO: "Rejeitado",
};

function batchStatusBadgeClass(status) {
  const map = {
    RASCUNHO: "pendente",
    AGUARDANDO_APROVACAO: "pendente",
    EM_PROCESSAMENTO: "pendente",
    PAGO: "aprovado",
    PARCIALMENTE_PAGO: "alerta",
    COM_ALERTA: "alerta",
    FALHOU: "alerta",
    REJEITADO: "alerta",
  };
  return map[status] || "pendente";
}

export default function PagamentoLoteDashboard() {
  const { stats, batches } = usePagamentoLote();

  return (
    <div className="paylote-page">
      <div className="paylote-inner col-md-10 m-auto mt-4">
        <div className="mb-3">
          <PageHeader
            title="Dashboard — Pagamento em Lote"
            pages={[{ name: "Pagamento em Lote", link: "/pagamento-lote/dashboard" }]}
          />
        </div>

        {/* Metrics */}
        <section className="paylote-metrics">
          <div className="paylote-metric-card">
            <div className="paylote-metric-icon blue">
              <TbLayoutList size={20} />
            </div>
            <div>
              <div className="paylote-metric-label">Total em lotes</div>
              <div className="paylote-metric-value">{formatValueToMonetary(stats.total.amount)}</div>
              <div className="paylote-metric-small">{stats.total.count} contas</div>
            </div>
          </div>

          <div className="paylote-metric-card">
            <div className="paylote-metric-icon orange">
              <TbClock size={20} />
            </div>
            <div>
              <div className="paylote-metric-label">Aguardando gestor</div>
              <div className="paylote-metric-value">{stats.pending.count}</div>
              <div className="paylote-metric-small">contas pendentes</div>
            </div>
          </div>

          <div className="paylote-metric-card">
            <div className="paylote-metric-icon red">
              <TbAlertTriangle size={20} />
            </div>
            <div>
              <div className="paylote-metric-label">Com alerta</div>
              <div className="paylote-metric-value">{stats.alert.count}</div>
              <div className="paylote-metric-small">precisam revisão</div>
            </div>
          </div>

          <div className="paylote-metric-card">
            <div className="paylote-metric-icon green">
              <TbCheck size={20} />
            </div>
            <div>
              <div className="paylote-metric-label">Aprovadas</div>
              <div className="paylote-metric-value">{formatValueToMonetary(stats.approved.amount)}</div>
              <div className="paylote-metric-small">{stats.approved.count} pagamentos</div>
            </div>
          </div>

          <div className="paylote-metric-card">
            <div className="paylote-metric-icon purple">
              <TbCalendarCheck size={20} />
            </div>
            <div>
              <div className="paylote-metric-label">Agendadas</div>
              <div className="paylote-metric-value">{stats.scheduled.count}</div>
              <div className="paylote-metric-small">próximos 7 dias</div>
            </div>
          </div>
        </section>

        {/* Últimos lotes */}
        <section className="paylote-table-card">
          <div className="paylote-dash-toolbar">
            <strong className="paylote-dash-section-title">Últimos lotes</strong>
            <Link to="/pagamento-lote/lotes" className="paylote-btn-secondary paylote-dash-see-all-link">
              Ver todos
            </Link>
          </div>

          <table>
            <thead>
              <tr>
                <th>Lote</th>
                <th>Criado por</th>
                <th>Contas</th>
                <th>Valor total</th>
                <th>Status</th>
                <th>Data</th>
              </tr>
            </thead>
            <tbody>
              {batches.map((batch) => (
                <tr key={batch.id}>
                  <td><strong>#{batch.id}</strong></td>
                  <td>{batch.createdByName}</td>
                  <td>{batch.totalBills}</td>
                  <td><strong>{formatValueToMonetary(batch.totalAmount)}</strong></td>
                  <td>
                    <span className={`paylote-badge ${batchStatusBadgeClass(batch.status)}`}>
                      {BATCH_STATUS_LABELS[batch.status] || batch.status}
                    </span>
                  </td>
                  <td className="paylote-dash-date-muted">{dateBR(batch.createdAt.split("T")[0])}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </section>

        {/* Quick access */}
        <div className="paylote-dash-quick-links">
          <Link to="/pagamento-lote/novo" className="paylote-btn-primary paylote-dash-link">
            + Novo lote
          </Link>
          <Link to="/pagamento-lote/aprovacao" className="paylote-btn-secondary paylote-dash-link">
            Ir para aprovação
          </Link>
          <Link to="/pagamento-lote/favorecidos" className="paylote-btn-secondary paylote-dash-link">
            Gerenciar favorecidos
          </Link>
        </div>
      </div>
    </div>
  );
}
